const pastePlainTextHandler = (e) => {
  e.preventDefault();

  const { ownerDocument: liveDocument } = e.target;
  const text = e.clipboardData.getData('text/plain');

  liveDocument.execCommand('insertText', false, text);
};

export default pastePlainTextHandler;
